import React from "react";

export default function CompanyIcon() {
  return (
    <svg
      width="257"
      height="234"
      viewBox="0 0 257 234"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 230V76C4 72.6863 6.68629 70 10 70H96C99.3137 70 102 72.6863 102 76V230"
        stroke="#0A4763"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        d="M102 230V10C102 6.68629 104.686 4 108 4H247C250.314 4 253 6.68629 253 10V230"
        stroke="#0A4763"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <rect x="27" y="98" width="16" height="21" fill="#EDEFF4" />
      <rect x="134" y="31" width="16" height="21" fill="#EDEFF4" />
      <rect x="134" y="164" width="16" height="21" fill="#EDEFF4" />
      <rect x="27" y="131" width="16" height="21" fill="#EDEFF4" />
      <rect x="134" y="64" width="16" height="21" fill="#EDEFF4" />
      <rect x="134" y="197" width="16" height="21" fill="#EDEFF4" />
      <rect x="27" y="165" width="16" height="21" fill="#EDEFF4" />
      <rect x="134" y="98" width="16" height="21" fill="#EDEFF4" />
      <rect x="27" y="198" width="16" height="21" fill="#EDEFF4" />
      <rect x="134" y="131" width="16" height="21" fill="#EDEFF4" />
      <rect x="63" y="98" width="16" height="21" fill="#EDEFF4" />
      <rect x="170" y="31" width="16" height="21" fill="#EDEFF4" />
      <rect x="170" y="164" width="16" height="21" fill="#EDEFF4" />
      <rect x="206" y="31" width="16" height="21" fill="#EDEFF4" />
      <rect x="206" y="164" width="16" height="21" fill="#EDEFF4" />
      <rect x="63" y="131" width="16" height="21" fill="#EDEFF4" />
      <rect x="170" y="64" width="16" height="21" fill="#EDEFF4" />
      <rect x="170" y="197" width="16" height="21" fill="#EDEFF4" />
      <rect x="206" y="64" width="16" height="21" fill="#EDEFF4" />
      <rect x="206" y="197" width="16" height="21" fill="#EDEFF4" />
      <rect x="63" y="165" width="16" height="21" fill="#EDEFF4" />
      <rect x="170" y="98" width="16" height="21" fill="#EDEFF4" />
      <rect x="206" y="98" width="16" height="21" fill="#EDEFF4" />
      <rect x="63" y="198" width="16" height="21" fill="#EDEFF4" />
      <rect x="170" y="131" width="16" height="21" fill="#EDEFF4" />
      <rect x="206" y="131" width="16" height="21" fill="#EDEFF4" />
    </svg>
  );
}
